<template>
  <div v-b-visible.500="handler" />
</template>

<script>
export default {
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    handler(_v) {
      this.isVisible = _v
      this.$emit('visible', _v)
    }
  }
}
</script>
